import IconV2 from './v2/IconV2';
import Link from './Link';
import Button from './Button.jsx';

const GetStartedBox = ({ icon, title, message, actions = [] }) => {
  return (
    <div className="comp-get-started-box">
      <div className={'inner-box'}>
        <div className={'left'}>
          <IconV2 icon={icon} className={'light'} />
        </div>
        <div className={'right'}>
          <div className={'title'}>{title}</div>
          <div className={'message'} dangerouslySetInnerHTML={{ __html: message }} />
          <div className={'actions'}>
            {actions.map((action, idx) => (
              <Link key={idx} to={action?.route}>
                <Button key={idx} icon={action.icon} className={action?.className} onClick={action.onClick} loading={action.loading} size={action.size} disabled={action.disabled}>
                  {action.label || ''}
                </Button>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedBox;
